import { render, staticRenderFns } from "./BuyoutItemsForm.vue?vue&type=template&id=317a0608"
import script from "./BuyoutItemsForm.vue?vue&type=script&lang=js"
export * from "./BuyoutItemsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports